var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress, Stack } from '@mui/material';
export var Loader = function () {
    return (_jsx(Stack, __assign({ alignItems: "center", justifyContent: "center", p: 4 }, { children: _jsx(CircularProgress, { color: "primary" }) })));
};
//# sourceMappingURL=Loader.js.map